import React from 'react';
import ResourceForm from '../ResourceForm';
import DataStepLayout from './DataStepLayout';
import DeleteButton from './DeleteButton';
import FigurePreview from './FigurePreview';
import StepShell from './StepShell';
import { pageImage } from './wizardUtils';

// Wizard step editing the plain attributes of a figure-like resource:
// preview on the left, form + delete action on the right.
export default function DataStep({ title, resource, fields, deletion, onNext, onCancel, loading }) {
  return (
    <StepShell>
      <DataStepLayout
        title={title}
        preview={
          <FigurePreview
            figures={resource?.figures}
            image={pageImage(resource)}
            showContours={false}
          />
        }
        deleteButton={deletion && <DeleteButton {...deletion} />}
      >
        <ResourceForm
          resource={resource}
          fields={fields}
          onSubmit={onNext}
          onCancel={onCancel}
          loading={loading}
          submitLabel="Save & Continue"
        />
      </DataStepLayout>
    </StepShell>
  );
}
